import { render, staticRenderFns } from "./EditResetPassword.vue?vue&type=template&id=4b52cb8c&"
import script from "./EditResetPassword.vue?vue&type=script&lang=js&"
export * from "./EditResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports